import { TipoEnderecoEnum } from 'graphql/types.generated'
import { isHyphen } from 'util/string/string-emptyOrHyphen'
import { cep, composeRules, createValidator, ErrorObject, maxLength, msg, required } from 'util/validation'

import { TerritorioViewTabEnum } from './components/list/TerritorioContentSwitch'
import { LogradouroEditFormModel, VisualizacaoTerritorialBuscaFormModel } from './model'

export const validateVisualizacaoTerritorialForm = (tabContext: TerritorioViewTabEnum) =>
  createValidator<VisualizacaoTerritorialBuscaFormModel>(
    {
      tipoEndereco: tabContext === TerritorioViewTabEnum.LISTA_DE_IMOVEIS ? [required] : [],
      equipe: [required],
      unidadeSaude: [required],
    },
    (value, errors): ErrorObject<VisualizacaoTerritorialBuscaFormModel> => {
      if (tabContext === TerritorioViewTabEnum.LISTA_DE_IMOVEIS) {
        if (TipoEnderecoEnum.LOGRADOURO === value.tipoEndereco) {
          errors.cep = composeRules([...cep])(value.cep)
        } else {
          errors.dsei = required(value.dsei)
          errors.poloBase = required(value.poloBase)
        }
      }

      return errors
    }
  )

export const validateLogradouroEditForm = () =>
  createValidator<LogradouroEditFormModel>(
    {
      cep: [required, cep],
      logradouro: [required, maxLength(72), validateEnderecoNaoInformado],
      tipoLogradouro: [required],
    },
    (value, errors): ErrorObject<LogradouroEditFormModel> => {
      errors.bairro = composeRules([required, maxLength(72), validateEnderecoNaoInformado])(value.bairro?.nome)
      return errors
    }
  )

const validateEnderecoNaoInformado = (value?: string) => {
  if (isHyphen(value)) {
    return msg('invalid', value)
  }
}
